import { JobType } from '@paragon/contract-library';

export const jobTypes: readonly JobType[] = ['Seal', 'Repair', 'SpecialEngineering'];
